import AuthService from 'library/authService/auth-service';
import { DEFAULT_PRESETS } from './availableSignOn';

// Day/Night shift presets for the current tenancy, in local site time
// (tenancy payload `ot_presets`, mapped to currentTenancy.otPresets by the auth services).
export const getOtPresets = () => {
  const user = AuthService.whoami() || {};
  const tenancy = user.currentTenancy || {};
  return tenancy.otPresets || DEFAULT_PRESETS;
};

export default getOtPresets;
